import { Popover as AntPopover } from "antd";
import type { PopoverProps } from "antd";
import { css } from "styled-components";
import { Inset } from "@shared/types";

const Popover = (props: PopoverProps) => {
  return <AntPopover {...props} />;
};
export default Popover;

export const popoverStyles = css<{
  $safeAreaInset?: Inset;
}>`
  .ant-popover {
    .ant-popover-inner,
    .ant-popover-arrow-content,
    .ant-popover-container {
      background: ${(p) => p.theme.colors.cardBgColor} !important;
      box-shadow: ${(p) =>
        p.theme.isDarkMode
          ? "#0000003d 0 6px 24px 0"
          : "rgba(100,100,111,0.2) 0 7px 29px 0"};
    }

    .ant-popover-inner-content {
      color: ${(p) => p.theme.colors.basic};
    }
  }
  .ant-popover.avatar {
    .ant-popover-inner,
    .ant-popover-arrow-content,
    .ant-popover-arrow:before {
      background-color: ${(p) => p.theme.colors.mediumBgColor}!important;
      background: ${(p) => p.theme.colors.mediumBgColor}!important;
    }
  }
  .ant-popover .ant-popover-arrow:before {
    background-color: ${(p) => p.theme.colors.cardBgColor}!important;
    background: ${(p) => p.theme.colors.cardBgColor}!important;
  }
  .ant-popover-inner {
    background-color: ${(p) => p.theme.colors.cardBgColor} !important;
    background: ${(p) => p.theme.colors.cardBgColor} !important;
    border-radius: 12px;
    box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;
  }
  .notification-modal-popover {
    .ant-popover-inner-content {
      padding: 0;
      overflow: hidden;
    }
    &.hide-arrow {
      .ant-popover-arrow {
        display: none;
      }
    }
  }
  .ant-popover.border .ant-popover-inner {
    border: ${(p) => p.theme.borders.medium};
  }
`;
